import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import '../css/PromoModal.css';

import qrCode from '../assets/promo/mechanic-finder-qr.png';
import appStoreBadge from '../assets/promo/app-store-badge.png';

const APP_STORE_LINK = 'https://apps.apple.com/ca/app/mechanicfinders/id6759413308';

export default function PromoModal() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const openTimer = setTimeout(() => {
      setIsOpen(true);
    }, 400);

    return () => {
      clearTimeout(openTimer);
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="promo-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="promo-modal-card"
            initial={{ opacity: 0, scale: 0.9, y: 35 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 18 }}
            transition={{ duration: 0.28 }}
          >
            <button
              className="promo-close-btn"
              onClick={handleClose}
              aria-label="Close promo"
              type="button"
            >
              <FaTimes />
            </button>

            <div className="promo-badge">MECHANIC FINDERS</div>

            <h2>Download the App</h2>
            <p>
              Scan the QR code to open Mechanic Finders on the App Store,
              or tap the App Store badge below.
            </p>

            <div className="promo-qr-wrap">
              <img
                src={qrCode}
                alt="Mechanic Finders QR Code"
                className="promo-qr"
              />
            </div>

            <a
              href={APP_STORE_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="promo-store-link"
            >
              <img
                src={appStoreBadge}
                alt="Download on the App Store"
                className="promo-store-badge"
              />
            </a>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}